import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CountdownService {
  private countdownSubject = new BehaviorSubject<string>('00');
  private remainingSeconds = 0;
  private intervalSub: any;

  get countdown$(): Observable<string> {
    return this.countdownSubject.asObservable();
  }

  public startCountdown(initialSeconds: number, useMinMaxRange = true) {
    if (this.intervalSub) {
      clearInterval(this.intervalSub);
    }

    this.remainingSeconds = useMinMaxRange ? Math.min(Math.max(initialSeconds, 0), 60) : initialSeconds; // Ensure within range
    this.updateCountdown();

    this.intervalSub = setInterval(() => {
      if (this.remainingSeconds > 0) {
        this.remainingSeconds--;
        this.updateCountdown();
      } else {
        clearInterval(this.intervalSub);
      }
    }, 1000);
  }

  public stopCountdown(): void {
    if (this.intervalSub) {
      clearInterval(this.intervalSub);
      this.intervalSub = null;
    }
    this.remainingSeconds = 0;
    this.countdownSubject.next('00');
  }

  private updateCountdown() {
    this.countdownSubject.next(this.formatTime(this.remainingSeconds));
  }

  private formatTime(time: number): string {
    return (time < 10 ? '0' : '') + time;
  }
}
